// Author thq
// Date 2023-10-15 15:21:39

class TpmOeeReportTor {
    constructor({
                    id = null,
                    torCodeBda = '',
                    torOperateSeqId = '',
                    torReportTime = '',
                    torProgramTime = '',
                    torWorkhourTime = '',
                    torOeeA = '',
                    torSpindleTime = '',
                    torSpindleTimeNoFilter = '',
                    torOeeP = '',
                    torOee = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.torCodeBda = torCodeBda;
        this.torOperateSeqId = torOperateSeqId;
        this.torReportTime = torReportTime;
        this.torProgramTime = torProgramTime;
        this.torWorkhourTime = torWorkhourTime;
        this.torOeeA = torOeeA;
        this.torSpindleTime = torSpindleTime;
        this.torSpindleTimeNoFilter = torSpindleTimeNoFilter;
        this.torOeeP = torOeeP;
        this.torOee = torOee;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmOeeReportTor();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torCodeBda',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torReportTime',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torReportTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torWorkhourTime',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torWorkhourTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torProgramTime',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torProgramTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torSpindleTime',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torSpindleTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torSpindleTimeNoFilter',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torSpindleTimeNoFilter',
            sortable: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torOee',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torOee',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torOeeA',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torOeeA',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'torOeeP',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.torOeeP',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },

        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmOeeReportTor.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    torCodeBdaFilter: '',
    torCodeBdaInFilter: [],
    torOperateSeqIdFilter: '',
    torReportTimeRteFilter: '',
    torReportTimeLteFilter: '',
    torProgramTimeFilter: '',
    torWorkhourTimeFilter: '',
    torOeeAFilter: '',
    torSpindleTimeFilter: '',
    torOeePFilter: '',
    torOeeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'torCodeBdaFilter',
        label: 'label.em.statusCollection.tpmOeeReportTor.filter.torCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torReportTimeRteFilter',
        label: 'label.em.statusCollection.tpmOeeReportTor.filter.torReportTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torReportTimeLteFilter',
        label: 'label.em.statusCollection.tpmOeeReportTor.filter.torReportTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'torCodeBda',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torCodeBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torReportTime',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torReportTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torProgramTime',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torProgramTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torWorkhourTime',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torWorkhourTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torOeeA',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torOeeA',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torSpindleTime',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torSpindleTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torSpindleTimeNoFilter',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torSpindleTimeNoFilter',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torOeeP',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torOeeP',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'torOee',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.torOee',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmOeeReportTor.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmOeeReportTor, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
